import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackLink({ to, label }) {
  return (
    <Link
      to={to}
      data-testid="back-link"
      className="inline-flex items-center gap-1.5 text-base text-muted-foreground hover:text-falu font-body no-underline mb-6 transition-colors"
    >
      <ArrowLeft size={18} />
      {label}
    </Link>
  );
}
